import { glsDecodeToken, glsResolveAccountId, GlsTokenClaims } from '@gls-its-frontends/common/gls-auth';
import { defineStore } from 'pinia';
import { computed, ComputedRef, ref, type Ref, watch } from 'vue';
import { LoginType } from '@/enums/login-type';
import { PartnerParcelNumberType } from '@/enums/partner-parcel-number-type';
import Role from '@/enums/role';
import { type AttributeStoreData } from '@/types';

const mainStoreKey: string = 'main';

const mainStore = defineStore(
    mainStoreKey,
    () => {
        const attributeStoreData: Ref<AttributeStoreData | null> = ref(null);
        const accessToken: Ref<string | null> = ref(null);
        const username: Ref<string | null> = ref(null);
        const userId: Ref<string> = ref('GPP_Frontend');
        const loginType: Ref<LoginType | null> = ref(null);
        const tokenShouldBeRefreshed: Ref<boolean> = ref(false);

        const roles: ComputedRef<Role[]> = computed((): Role[] => attributeStoreData.value?.role || []);
        const partnerParcelNumberTypes: ComputedRef<PartnerParcelNumberType[]> = computed((): PartnerParcelNumberType[] =>
            attributeStoreData.value?.partnerParcelNumberTypes ? [...attributeStoreData.value.partnerParcelNumberTypes].sort() : []
        );
        const claims: ComputedRef<GlsTokenClaims | null> = computed((): GlsTokenClaims | null =>
            !accessToken.value ? null : glsDecodeToken(accessToken.value)
        );
        const oid: ComputedRef<string | null> = computed((): string | null => (!claims.value ? null : glsResolveAccountId(claims.value)));

        watch(oid, (newOid: string | null): void => {
            if (newOid === attributeStoreData.value?.oid) {
                return;
            }

            attributeStoreData.value = null;
        });

        return {
            attributeStoreData,
            claims,
            oid,
            accessToken,
            username,
            userId,
            loginType,
            roles,
            tokenShouldBeRefreshed,
            partnerParcelNumberTypes
        };
    },
    {
        persist: {
            pick: ['attributeStoreData', 'tokenShouldBeRefreshed']
        }
    }
);

export default mainStore;
